export default function BenefitsSection() {
  const benefits = [
    {
      icon: "ri-file-text-line",
      title: "No Personal Income Verification",
      description: "Qualify based on the property's rental income and cash flow, not your personal income or tax returns.",
      color: "from-blue-500 to-emerald-500"
    },
    {
      icon: "ri-speed-line",
      title: "Fast Approval Process",
      description: "Streamlined application and approval process designed specifically for real estate investors.",
      color: "from-emerald-500 to-teal-500"
    },
    {
      icon: "ri-building-line",
      title: "Multiple Properties",
      description: "Finance multiple investment properties without the traditional lending restrictions.",
      color: "from-teal-500 to-blue-500"
    },
    {
      icon: "ri-shield-check-line",
      title: "Flexible Terms",
      description: "Competitive rates and flexible loan terms tailored to your investment strategy.",
      color: "from-blue-500 to-emerald-500"
    },
    {
      icon: "ri-line-chart-line",
      title: "Portfolio Growth",
      description: "Scale your real estate portfolio faster with property-based qualification.",
      color: "from-emerald-500 to-teal-500"
    },
    {
      icon: "ri-user-star-line",
      title: "Expert Guidance",
      description: "Benefit from our proven experience in successfully funding investment properties.",
      color: "from-teal-500 to-blue-500"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 via-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-600 to-emerald-600 text-white rounded-full text-sm font-semibold mb-8 shadow-lg">
            <i className="ri-star-fill mr-2"></i>
            Why Choose DSCR Loans
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Benefits of DSCR Financing
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            DSCR (Debt Service Coverage Ratio) loans are designed for real estate investors who want to grow their portfolio without traditional income verification hurdles.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="group bg-white rounded-xl p-8 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 border border-slate-100 hover:border-emerald-200"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${benefit.color} rounded-xl flex items-center justify-center mb-6 shadow-lg group-hover:shadow-xl transform group-hover:scale-110 transition-all duration-300`}>
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{benefit.title}</h3>
              <p className="text-slate-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
